import { generateApiFilters } from "PFApp/components/filters_v2/helpers/generate_api_filters";
import { DEFAULT_PAGE, PER_PAGE_UNPAGINATED } from "PFApp/constants/unpaginated";
import { LegacyGetProfilesCollection } from "PFApp/legacy_cv_export_flow";
import { fetchActivityWatchers } from "PFCore/services/activities";
import { fetchExportProfiles } from "PFCore/services/export_profiles";
import { Id } from "PFTypes";

import { RoleWatcher } from "../../../../../types/watchers";
import useFormatWatchersToCsv from "./hooks/use_format_watchers_to_csv";

type GetLegacyCvExportCollectionsParams = {
  activityId: Id;
  profilesForExport: RoleWatcher[];
  filtersV2Meta: Parameters<typeof generateApiFilters>[0];
  formatWatchers: ReturnType<typeof useFormatWatchersToCsv>;
};

// Legacy CV export flow copied from uat, used only when the cv_export_legacy_flow feature flag is ON.
// Meant to be removed together with the flag.
export const getLegacyCvExportCollections = ({
  activityId,
  profilesForExport,
  filtersV2Meta,
  formatWatchers
}: GetLegacyCvExportCollectionsParams) => {
  const fetchProfilesForExport = () =>
    fetchExportProfiles({
      profileIds: profilesForExport.map(({ profile }) => profile.id),
      activityId: activityId
    }).then((resp) => ({
      entries: resp.map((profile) => ({
        profile
      })),
      meta: { total: resp.length, page: 1 }
    }));

  const getRawCollection = () =>
    fetchActivityWatchers(
      activityId,
      DEFAULT_PAGE,
      PER_PAGE_UNPAGINATED,
      generateApiFilters(filtersV2Meta)
    ).then((res) => ({
      ...res,
      entries: formatWatchers(res.entries)
    }));

  return {
    getProfilesCollection: fetchProfilesForExport as LegacyGetProfilesCollection,
    getRawCollection
  };
};
